import { Box, Card, CardContent, Container, Divider, Typography } from '@mui/material';

import { useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { AriOkIcon } from '~/assets/icons';
import { center, title } from '~/pages/PaymentConfirm/styles';
import logoFull from '../../../assets/images/logo-full.png';
import { CardAjust } from './components/CardAjust';
import { ContractInfo } from './components/ContractInfo';
import useFetchContract from './hooks/useFetchContract';
import { cardContainer, cardHeader, container } from './styles';
import { Contract } from './types/contratResponse';

export default function ConfigContract() {
  const { contractId: contractIdHash } = useParams();
  const [searchParams] = useSearchParams();
  const { contract, loading } = useFetchContract(contractIdHash ?? '', searchParams.get('org') ?? undefined);
  const organizationId = searchParams.get('org') ?? contract?.organization_id ?? undefined;
  const [cardEdit, setCardEdit] = useState(false);
  const [sucessRequest, setSucessRequest] = useState(false);

  if (loading) {
    return <>CARREGANDO OS DADOS</>;
  }

  if (sucessRequest) {
    return (
      <Container maxWidth="sm" sx={container}>
        <Box sx={[center]}>
          <AriOkIcon />
          <Typography variant="h5" sx={center} fontWeight="bold">
            Cartão de crédito alterado com sucesso
          </Typography>
        </Box>
        <Box sx={[center]}>
          <Typography color="primary" variant="h4" sx={title}>
            Parabêns
          </Typography>
        </Box>
        <Box sx={[center]}>
          <Typography color="primary" sx={title} textAlign="center">
            Sua proxima cobrança virá no novo cartão cadastrado
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={container}>
      <Card sx={cardContainer}>
        <CardContent>
          <Box sx={cardHeader}>
            <Box sx={[center]}>
              <img width={200} src={logoFull} />
            </Box>

            <Typography variant="h6" align="center" sx={{ fontSize: '1.6rem' }}>
              Configuração da assinatura
            </Typography>
          </Box>
          <Divider variant="middle" />
          {cardEdit ? (
            <CardAjust
              contractCode={contract?.contract_code ?? ''}
              contractId={contractIdHash ?? ''}
              setSucessRequest={setSucessRequest}
              contractPaymentMethod={contract?.payment_method ?? 'credit_card'}
              organizationId={organizationId}
            />
          ) : (
            <ContractInfo contract={contract ?? ({} as Contract)} setCardEdit={setCardEdit} />
          )}
        </CardContent>
      </Card>
    </Container>
  );
}
